import React from 'react';
import styled from 'styled-components';
import { IProblemCostResult } from '../utils/problemTypeUtils';

type ProblemCostSummaryProps = {
  costResult: IProblemCostResult;
  index?: number;
};

const ProblemCostSummary = ({ costResult, index }: ProblemCostSummaryProps) => {
  const { difference, isLoss, label } = costResult;
  
  if (difference === 0) return null;

  const sign = isLoss ? '-' : '+';

  return (
    <Wrapper $isLoss={isLoss}>
      {
        index !== undefined && (
          <Index>#{index + 1}</Index>
        )
      }
      <Amount $isLoss={isLoss}>
        {sign}{difference.toFixed(2)} ₪
      </Amount>
      <Label>{label}</Label>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $isLoss: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75em;
  padding: 0.5em 0.75em;
  background: ${props => props.$isLoss ? 'rgba(220, 53, 69, 0.08)' : 'rgba(40, 167, 69, 0.08)'};
  border-radius: 8px;
  border-right: 3px solid ${props => props.$isLoss ? '#dc3545' : '#28a745'};
`;

const Index = styled.span`
  font-size: 0.8em;
  font-weight: 600;
  color: #6c757d;
`;

const Amount = styled.span<{ $isLoss: boolean }>`
  font-size: 1em;
  font-weight: 700;
  color: ${props => props.$isLoss ? '#dc3545' : '#28a745'};
  font-family: 'Assistant', sans-serif;
`;

const Label = styled.span`
  font-size: 0.85em;
  color: #495057;
  font-family: 'Assistant', sans-serif;
`;

export default ProblemCostSummary;

